import { useEffect, useRef } from 'react'
import {
  Pressable,
  Image,
  ScrollView,
  ViewStyle,
  View,
} from 'react-native'
import useDimension from '../../hooks/use-dimension'
import { motion } from 'framer-motion'
import { ContentType } from '../../data/contents'
import { imgCommons } from '../../data/images'
import { useGameContext } from '../../context/GameContext'

const { roles } = imgCommons
type RoleKey = 'a' | 'b' | 'c' | 'd' | 'e'

type Props = {
  btn?: {
    btnSrc: string
    btnBack?: string
    onPress: () => void
    pLast?: boolean
    onBack?: () => void
  }
  txts: ContentType[]
  side?: string
  page?: number
}
export default function Story({ btn, txts, side, page }: Props) {
  const { ws } = useDimension()
  const { role } = useGameContext() as { role: RoleKey }
  const ref = useRef<ScrollView>(null)

  useEffect(() => {
    if (!ref || !ref.current) return
    ref.current.scrollTo({ y: 0, animated: true })
  }, [ref, txts])

  const { btnSrc, onPress, onBack, btnBack } = btn ?? {}

  const scrollStyles1: ViewStyle = {
    width: 360 * ws,
    height: 180 * ws,
    // maxHeight: 120 * ws,
    backgroundColor: '#f7faff99',
    // paddingBlock: 18 * ws,
    paddingInline: 10 * ws,
    position: 'absolute',
    top: 420 * ws,
    left: 0 * ws,
  }

  const scrollStyles2: ViewStyle = {
    width: 310 * ws,
    // height: 200 * ws,
    maxHeight: 200 * ws,
    position: 'absolute',
    // backgroundColor: '#fff9',
    top: 110.5 * ws,
    left: 24.5 * ws,
  }

  // 文字動畫用
  const renderAnimatedText = (text: string, textStyle: any) => {
    const paragraphs = text.split('\n')

    return (
      <motion.div
        style={{
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
        }}
      >
        <div
          // key={pIndex}
          style={{
            width: '100%',
            justifyContent: 'center',
            padding: 10 * ws,
            // marginBottom:
            //   pIndex < paragraphs.length - 1 ? 16 * ws : 0,
            backgroundColor: side === 'down' ? '' : '#fffd',
            boxShadow:
              side === 'down' ? '' : '0px 0px 50px 30px #fff',
          }}
        >
          {paragraphs.map((paragraph, pIndex) => (
            <motion.div
              key={pIndex}
              style={{
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'wrap',
                marginBottom:
                  pIndex < paragraphs.length - 1 ? 16 * ws : 0,
              }}
            >
              {paragraph.split('').map((char, charIndex) => (
                <motion.span
                  key={`${pIndex}-${charIndex}`}
                  initial={{ opacity: 0, y: 0 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{
                    duration: 0.3,
                    delay:
                      (pIndex * paragraph.length + charIndex) * 0.02,
                  }}
                  style={{
                    color: '#1f4d75',
                    fontFamily: 'love',
                    lineHeight: 1.5,
                    letterSpacing: 1.45 * ws,
                    fontWeight: '500',
                    whiteSpace: 'pre-line',
                    textAlign: 'justify',
                    fontSize: (textStyle?.fontSize ?? 14) * ws,
                  }}
                >
                  {char}
                </motion.span>
              ))}
            </motion.div>
          ))}
        </div>
      </motion.div>
    )
  }

  return (
    <>
      {side === 'down' && role && (
        <View
          style={{
            width: 133 * ws,
            height: 30 * ws,
            position: 'absolute',
            left: 0,
            top: 390 * ws,
          }}
        >
          <Image
            source={{ uri: roles[role].name }}
            style={{
              width: '100%',
              height: '100%',
            }}
            resizeMode="contain"
            aria-label={`content`}
          />
        </View>
      )}
      <View
        // ref={ref}
        style={side === 'down' ? scrollStyles1 : scrollStyles2}
      >
        {txts.map((content, idx) => {
          //@ts-ignore
          const { text, textStyle, img, imgStyle, children } = content

          if (!!text)
            return (
              // 無文字動畫
              // <p
              //   key={idx}
              //   style={{
              //     color: '#1f4d75',
              //     fontFamily: 'love',
              //     lineHeight: 1.5,
              //     alignSelf: 'center',
              //     letterSpacing: 1.45 * ws,
              //     fontWeight: '500',
              //     whiteSpace: 'pre-line',
              //     textAlign: 'justify',
              //     // lineBreak: 'anywhere',
              //     ...textStyle,
              //     fontSize: (textStyle?.fontSize ?? 14) * ws,
              //   }}
              //   dangerouslySetInnerHTML={{ __html: text }}
              // ></p>
              <div key={idx}>
                <Pressable onPress={onPress}>
                  {renderAnimatedText(text, textStyle)}
                </Pressable>
              </div>
            )
          else if (!!img)
            return (
              <Image
                key={idx}
                source={{ uri: img }}
                style={{
                  width: imgStyle.width * ws,
                  height: imgStyle.height * ws,
                  marginTop: imgStyle.marginTop * ws,
                }}
                resizeMode="contain"
                aria-label={`content`}
              />
            )
          else return children
        })}
        {btn?.pLast && (
          <Pressable
            style={{
              width: 160 * ws,
              height: 80 * ws,
              alignSelf: 'center',
            }}
            onPress={onPress}
          >
            <Image
              source={{ uri: btnSrc }}
              resizeMode="contain"
              style={{
                width: '100%',
                height: '100%',
                alignSelf: 'center',
                marginTop: -20 * ws,
              }}
              aria-label={`btn-next`}
            />
          </Pressable>
        )}
      </View>
      {/* 下一段 */}
      {!btn?.pLast && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1, duration: 1 }}
        >
          <Pressable
            style={{
              // marginTop: 25 * ws,
              width: 21 * ws,
              height: 73.5 * ws,
              position: 'absolute',
              top: 306 * ws,
              left: 339 * ws,
            }}
            onPress={onPress}
          >
            <Image
              source={{ uri: btnSrc }}
              resizeMode="contain"
              style={{
                width: '100%',
                height: 52 * ws,
                alignSelf: 'center',
              }}
              aria-label={`btn-next`}
            />
          </Pressable>
        </motion.div>
      )}
      {/* 上一段 */}
      {btn?.btnBack && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1, duration: 1 }}
          style={{ rotate: 180 }}
        >
          <Pressable
            style={{
              // marginTop: 25 * ws,
              width: 21 * ws,
              height: 73.5 * ws,
              position: 'absolute',
              top: -35 * ws,
              left: 159 * ws,
              // zIndex: 10,
            }}
            onPress={onBack}
          >
            <Image
              source={{ uri: btnBack }}
              resizeMode="contain"
              style={{
                width: '100%',
                height: 52 * ws,
                alignSelf: 'center',
              }}
              aria-label={`btn-next`}
            />
          </Pressable>
        </motion.div>
      )}
    </>
  )
}
